// @flow @format
import {handleActions} from 'lib/redux-actions';

import type {FileNode, File} from 'lib/cloner-api';

export type State = {
	entities: {[fileId: ?string]: FileNode},
	versions: {[fileId: ?string]: File[]},
	showDeleted: boolean,
};

export type FetchFileNodeAction = {
	type: string,
	fileId: string,
	repositoryId: string,
};

export type FetchFileVersionsAction = {
	type: string,
	fileId: string,
	repositoryId: string,
};

type AddFileNodeAction = {
	type: string,
	fileId: string,
	payload: FileNode,
};

type AddFileVersionsAction = {
	type: string,
	fileId: string,
	payload: File[],
};

// async actions
export const FETCH_FILE_NODE = 'FETCH_FILE_NODE';
export const FETCH_FILE_VERSIONS = 'FETCH_FILE_VERSIONS';

export const fetchFileNode = (
	fileId: string,
	repositoryId: string,
): FetchFileNodeAction => ({
	fileId,
	repositoryId,
	type: FETCH_FILE_NODE,
});

export const fetchFileVersions = (
	fileId: string,
	repositoryId: string,
): FetchFileVersionsAction => ({
	fileId,
	repositoryId,
	type: FETCH_FILE_VERSIONS,
});

// actions
export const ADD_FILE_NODE = 'ADD_FILE_NODE';
export const ADD_FILE_VERSIONS = 'ADD_FILE_VERSIONS';
export const TOGGLE_FILES_DELETED = 'TOGGLE_FILES_DELETED';

export const addFileNode = (
	fileId: string,
	fileNode: FileNode,
): AddFileNodeAction => ({
	fileId,
	type: ADD_FILE_NODE,
	payload: fileNode,
});

export const addFileVersions = (
	fileId: string,
	files: File[],
): AddFileVersionsAction => ({
	fileId,
	type: ADD_FILE_VERSIONS,
	payload: files,
});

export const toggleFilesDeleted = () => ({type: TOGGLE_FILES_DELETED});

export const initialState: State = {
	entities: {},
	versions: {},
	showDeleted: false,
};

const reducer = handleActions(
	{
		[ADD_FILE_NODE]: (state: State, action: AddFileNodeAction): State => {
			const entities = {...state.entities};
			entities[action.fileId] = action.payload;

			return {...state, entities};
		},
		[ADD_FILE_VERSIONS]: (
			state: State,
			action: AddFileVersionsAction,
		): State => {
			const versions = {...state.versions};
			versions[action.fileId] = action.payload;

			return {...state, versions};
		},
		[TOGGLE_FILES_DELETED]: (state: State): State => ({
			...state,
			showDeleted: !state.showDeleted,
		}),
	},
	initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/entities/files.js